import React, { useEffect, useState,useMemo } from "react";
import Web3 from "web3";

import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import NFTABI from "../abis/NFTABI.json";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";

import { NFTContarct, ITreasureContract,USDTContarct,DepositContract } from "../config/contractConfig";
import ConfirmBuyModal from "../components/ConfirmBuyModal";
import { FaFilter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import USDTABI from "../abis/USDTABI.json";
import DepositAbi from "../abis/DepositAbi.json";

const AdminPanel = () => {
  const navigate = useNavigate();
  
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [poolValue, setPoolValue] = useState("0.00");
  const [isResetting, setIsResetting] = useState(false);

  // ===== FORM STATES =====
  const [mintCount, setMintCount] = useState(1);
  const [basePrice, setBasePrice] = useState("");
  const [burnPrice, setBurnPrice] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [search, setSearch] = useState("");
  // ===== BOT USERS =====
  const [botUsers, setBotUsers] = useState([]);
  const [botLoading, setBotLoading] = useState(false);

  const [regWallet, setRegWallet] = useState("");
const [regReferral, setRegReferral] = useState("");
const [regRank, setRegRank] = useState(1);
  const [lockWallet, setLockWallet] = useState("");


const [purchaseWallet, setPurchaseWallet] = useState("");
const [selectedPackages, setSelectedPackages] = useState([]);

const [totalRoyaltyUsers, setTotalRoyaltyUsers] = useState(0);
const [totalQualifiedCount, setTotalQualifiedCount] = useState(0);

const [royaltyUser, setRoyaltyUser] = useState("");
const [royaltyAmount, setRoyaltyAmount] = useState("");
const [royaltyRank, setRoyaltyRank] = useState("1");

const [roleWallet, setRoleWallet] = useState("");
const [roleStatus, setRoleStatus] = useState(true);

const [fundWallet, setFundWallet] = useState("");
const [fundAmount, setFundAmount] = useState("");

const isBurnQualified = (rank, burned) => {
  if (rank === 1) return burned >= 3;
  if (rank === 2) return burned >= 6;
  if (rank === 3) return burned >= 9;
  if (rank === 4) return burned >= 12;
  return false;
};

  // ===== MODAL STATE (SAME PATTERN AS AUTOTRADING) =====
  const [modalStatus, setModalStatus] = useState({
    visible: false,
    type: "",       // loading | success | error | confirm
    title: "",
    message: "",
    persist: false,
    onConfirm: null
  });

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

  const togglePackage = (pkgId) => {
  setSelectedPackages((prev) => {
    if (prev.includes(pkgId)) {
      return prev.filter((id) => id !== pkgId);
    }
    return [...prev, pkgId];
  });
};

const sanitizeAddress = (addr) => {
  if (!addr) return "";

  // remove all spaces
  const cleaned = addr.replace(/\s+/g, "").trim();

  return cleaned;
};



  // ===== INIT WEB3 =====
  useEffect(() => {
    let provider = null;

    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;

    if (provider) setWeb3(new Web3(provider));
    
    const fetchBotUsers = async () => {
      try {
        setBotLoading(true);
        const res = await fetch(
          "https://daemon.takshitsolutions.com/api/app/v1/get-enabled-bot-users"
        );
        const json = await res.json();
        if (!json.isError) {
          setBotUsers(json.data || []);
        }
      } catch (err) {
        console.error("Bot API Error:", err);
      } finally {
        setBotLoading(false);
      }
    };

    fetchBotUsers();
  }, [client]);

  useEffect(() => {
  if (web3 && isConnected) {
    fetchSystemDetails();
    fetchRoyaltyUsers();
  }
}, [web3, isConnected, address]);

   // ===== FILTER LOGIC =====
  const filteredUsers = useMemo(() => {
    return botUsers.filter((u) => {
      let ok = true;

      if (search) {
        ok =
          u.Wallet &&
          u.Wallet.toLowerCase().includes(search.toLowerCase());
      }

      if (ok && fromDate) {
        ok = new Date(u.ActiveDateTime) >= new Date(fromDate);
      }

      if (ok && toDate) {
        ok = new Date(u.ActiveDateTime) <= new Date(toDate);
      }

      return ok;
    });
  }, [botUsers, search, fromDate, toDate]);

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setSearch("");
  };

   const handleLevelIncome = async () => {
  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Please connect admin wallet",
      persist: true,
    });
    return;
  }
  const cleanWallet = sanitizeAddress(lockWallet);

  if (!cleanWallet) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Invalid Input",
      message: "Wallet  address required",
      persist: true,
    });
    return;
  }

  try {
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Unlock Level user...",
    });

    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    await Contract.methods
      .resetUserLevelTimer(cleanWallet)
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "User Level Unlock successfully",
    });

    // clear form
    setLockWallet("");


  } catch (err) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Failed",
      message: err.message,
      persist: true,
    });
  }
};


const handleRoleAllocation = async () => {
  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Please connect OWNER wallet",
      persist: true,
    });
    return;
  }

  const cleanWallet = sanitizeAddress(roleWallet);

  if (!cleanWallet) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Invalid Input",
      message: "Wallet address required",
      persist: true,
    });
    return;
  }

  try {

    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Updating role...",
    });

    const contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    await contract.methods
      .newRoleAllocation(cleanWallet, roleStatus)
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "User role updated successfully",
    });

    setRoleWallet("");
    setRoleStatus(true);

  } catch (err) {

    setModalStatus({
      visible: true,
      type: "error",
      title: "Transaction Failed",
      message: err.message,
      persist: true,
    });

  }
};

  const handleEnrollRegister = async () => {
  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Please connect admin wallet",
      persist: true,
    });
    return;
  }
  const cleanWallet = sanitizeAddress(regWallet);
   const cleanReferral = sanitizeAddress(regReferral);

  if (!cleanWallet || !cleanReferral) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Invalid Input",
      message: "Wallet and referral address required",
      persist: true,
    });
    return;
  }

  try {
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Registering user...",
    });

    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    await Contract.methods
      .enrollRegister(cleanWallet, cleanReferral, regRank,2)
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "User registered successfully",
    });

    // clear form
    setRegWallet("");
    setRegReferral("");
    setRegRank(1);

  } catch (err) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Failed",
      message: err.message,
      persist: true,
    });
  }
};

const handleEnrollPurchase = async () => {
  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Please connect admin wallet",
      persist: true,
    });
    return;
  }
  
const cleanWallet = sanitizeAddress(purchaseWallet);
  if (!cleanWallet || selectedPackages.length === 0) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Invalid Input",
      message: "Wallet and at least one package are required",
      persist: true,
    });
    return;
  }

  try {
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Purchasing packages...",
    });

    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

     // ✅ USER REGISTER CHECK (INSIDE TRY)
    const user = await Contract.methods.objUser(cleanWallet).call();
    if (!user?.userId || user.userId === "0") {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Not Registered",
        message: "User is not registered.",
        persist: true,
      });
      return; // ❌ STOP HERE
    }

    const timeStamp = Math.floor(Date.now() / 1000);

    await Contract.methods
      .enrollPurchase(cleanWallet, selectedPackages, timeStamp)
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "Packages purchased successfully",
    });

    // reset
    setPurchaseWallet("");
    setSelectedPackages([]);

  } catch (err) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Failed",
      message: err.message,
      persist: true,
    });
  }
};



  // ===== ADMIN BATCH MINT =====
  const handleAdminBatchMint = async () => {
    if (!isConnected || !address) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Wallet Required",
        message: "Please connect OWNER wallet"
      });
      return;
    }

    if (!mintCount || mintCount <= 0) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Invalid Input",
        message: "Enter valid mint count"
      });
      return;
    }

    try {
      setModalStatus({
        visible: true,
        type: "loading",
        title: "Processing",
        message: "Waiting for wallet confirmation..."
      });

      const contract = new web3.eth.Contract(NFTABI, NFTContarct);

      await contract.methods.adminBatchMint(mintCount).send({
        from: address
      });

      setModalStatus({
        visible: true,
        type: "success",
        title: "Success",
        message: `Successfully minted ${mintCount} NFTs`
      });
    } catch (err) {
      console.error(err);
      setModalStatus({
        visible: true,
        type: "error",
        title: "Transaction Failed",
        message: "Only contract owner can mint NFTs"
      });
    }
  };

//   const fetchRoyaltyUsers = async () => {
//   if (!web3) return;

//   try {
//     const contract = new web3.eth.Contract(
//       ITreasureContractABI,
//       ITreasureContract
//     );

//     const allRanks = [];
//     let totalCount = 0; // 🔥 total counter

//     for (let rank = 1; rank <= 4; rank++) {
//       const result = await contract.methods
//         .getAllRoyaltyRankUsers(rank)
//         .call();

//       const count = Number(result.userCount);

//       totalCount += count; // 🔥 ADD HERE

//       allRanks.push({
//         rank: rank,
//         userCount: count,
//         users: result.users,
//       });
//     }

//     setTotalRoyaltyUsers(totalCount); // 🔥 STORE TOTAL

//     console.log("Royalty Rank Users:", allRanks);
//   } catch (err) {
//     console.error("Royalty Fetch Error:", err);
//   }

// };

const fetchRoyaltyUsers = async () => {
  if (!web3) return;

  try {
    const royaltyContract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    const nftContract = new web3.eth.Contract(
      NFTABI,
      NFTContarct
    );

    let qualifiedCount = 0;

    for (let rank = 1; rank <= 4; rank++) {
      const result = await royaltyContract.methods
        .getAllRoyaltyRankUsers(rank)
        .call();

      for (let i = 0; i < result.users.length; i++) {
        const userAddr = result.users[i];

        if (
          userAddr ===
          "0x0000000000000000000000000000000000000000"
        )
          continue;

        const burned = Number(
          await nftContract.methods.getBurnToken(userAddr).call()
        );

        // 🔥 ONLY COUNT QUALIFIED
        if (isBurnQualified(rank, burned)) {
          qualifiedCount++;
        }
      }
    }

    // ✅ FINAL RESULT
    setTotalQualifiedCount(qualifiedCount);
  } catch (err) {
    console.error("Royalty Count Error:", err);
  }

};



   // FETCH SYSTEM DETAILS
    const fetchSystemDetails = async () => {
      try {
        const contract = new web3.eth.Contract(
          ITreasureContractABI,
          ITreasureContract
        );
        const result = await contract.methods.getSystemDetails().call();
  
        const ctoCommission = web3.utils.fromWei(
          result[5].toString(),
          "ether"
        );
  
        setPoolValue(formatBalance(ctoCommission));
      } catch (error) {
        console.error("Error fetching tPool:", error);
      }
    };

  // ===== SET MINT RESOLVER (18 DECIMAL) =====
  const handleSetMintResolver = async () => {
    if (!isConnected || !address) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Wallet Required",
        message: "Please connect OWNER wallet"
      });
      return;
    }

    if (!basePrice || !burnPrice) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Invalid Input",
        message: "Enter both prices"
      });
      return;
    }

    try {
      setModalStatus({
        visible: true,
        type: "loading",
        title: "Updating",
        message: "Updating mint resolver..."
      });

      const contract = new web3.eth.Contract(NFTABI, NFTContarct);

      const basePriceWei = web3.utils.toWei(basePrice.toString(), "ether");
      const burnPriceWei = web3.utils.toWei(burnPrice.toString(), "ether");

      await contract.methods
        .setMintResolver(basePriceWei, burnPriceWei)
        .send({ from: address });

      setModalStatus({
        visible: true,
        type: "success",
        title: "Success",
        message: "Mint resolver updated successfully"
      });
    } catch (err) {
      console.error(err);
      setModalStatus({
        visible: true,
        type: "error",
        title: "Update Failed",
        message: "Only owner can update mint resolver"
      });
    }
  };

  const handleEnableFundUser = async () => {

  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Please connect OWNER wallet",
      persist: true,
    });
    return;
  }

  const cleanWallet = sanitizeAddress(fundWallet);

  if (!cleanWallet || !fundAmount) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Invalid Input",
      message: "Wallet and amount required",
      persist: true,
    });
    return;
  }

  try {

    const nftContract = new web3.eth.Contract(
      DepositAbi,
      DepositContract
    );

    const usdtContract = new web3.eth.Contract(
      USDTABI,
      USDTContarct
    );

    const amountWei = web3.utils.toWei(
      fundAmount.toString(),
      "ether"
    );

    // STEP 1 APPROVE
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Approving USDT",
      message: "Please confirm approval...",
    });

    await usdtContract.methods
      .approve(DepositContract, amountWei)
      .send({ from: address });

    // STEP 2 ENABLE FUND
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Enabling trading fund...",
    });

    await nftContract.methods
      .enableFundUser(cleanWallet, amountWei)
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "Trading fund enabled successfully",
    });

    setFundWallet("");
    setFundAmount("");

  } catch (err) {

    setModalStatus({
      visible: true,
      type: "error",
      title: "Transaction Failed",
      message: err.message,
      persist: true,
    });

  }
};

  // ===== DISTRIBUTE ROYALTY =====
  
    const handleDistributeRoyalty = async () => {
      if (!isConnected || !address) {
        setModalStatus({
          visible: true,
          type: "error",
          title: "Wallet Required",
          message: "Please connect OWNER wallet",
        });
        return;
      }
    
      if (!royaltyUser || !royaltyAmount || !royaltyRank) {
        setModalStatus({
          visible: true,
          type: "error",
          title: "Invalid Input",
          message: "Please enter user, amount and rank",
        });
        return;
      }
    
      try {
        setModalStatus({
          visible: true,
          type: "loading",
          title: "Processing",
          message: "Distributing royalty...",
        });
    
        const contract = new web3.eth.Contract(
          ITreasureContractABI,
          ITreasureContract
        );
    
        const amountWei = web3.utils.toWei(
          royaltyAmount.toString(),
          "ether"
        );
    
        await contract.methods
          .distributeRoyaltyIncome(
            royaltyUser,
            amountWei,
            Number(royaltyRank)
          )
          .send({ from: address });
    
        setModalStatus({
          visible: true,
          type: "success",
          title: "Success",
          message: "Royalty distributed successfully",
        });
    
        // reset form
        setRoyaltyUser("");
        setRoyaltyAmount("");
        setRoyaltyRank("1");
    
      } catch (err) {
        console.error(err);
        setModalStatus({
          visible: true,
          type: "error",
          title: "Failed",
          message: err?.message || "Royalty distribution failed",
        });
      }
    };
    
    
    const handleResetRoyalty = async () => {
      if (!isConnected || !address) {
        setModalStatus({
          visible: true,
          type: "error",
          title: "Wallet Required",
          message: "Please connect OWNER wallet",
        });
        return;
      }
    
      const confirmReset = window.confirm(
        "⚠️ This will reset the current royalty month.\n" +
        "All rank users will be cleared and re-registered for the new month.\n\n" +
        "Do you want to continue?"
      );
    
      if (!confirmReset) return;
    
      try {
        setIsResetting(true);
    
        setModalStatus({
          visible: true,
          type: "loading",
          title: "Resetting",
          message: "Resetting royalty month...",
        });
    
        const contract = new web3.eth.Contract(
          ITreasureContractABI,
          ITreasureContract
        );
    
        await contract.methods
          .resetRoyaltyDataOnly()
          .send({ from: address });
    
        setModalStatus({
          visible: true,
          type: "success",
          title: "Reset Complete",
          message: "Royalty month reset successfully",
        });
    
    
      } catch (err) {
        console.error(err);
        setModalStatus({
          visible: true,
          type: "error",
          title: "Reset Failed",
          message: err?.message || "Royalty reset failed",
        });
      } finally {
        setIsResetting(false);
      }
    };
    
    const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  // ===== JSX =====
  return (
    <>
<div className="reserve-report">

  {/* ===== Header ===== */}
  <div className="mb-3 main-top-herder">
    <div>
      <h3 className="fw-bold text-light">
      <span className="text-warning">NFT</span>{" "}
      <span className="fw-lighter">Admin Panel</span>
    </h3>
    <p className="text-white mb-0">
      Manage minting, royalty distribution, and pricing controls
    </p>
    </div>
    {/* <button onClick={() => navigate("/all-nft-details-price")} className="btn btn-outline-warning btn-secondary-ui">
                      Check NFT Details
                    </button> */}
     {/* <button onClick={() => navigate("/adm0F7in26-coA4mpanb0Ay-de485tail73s-only-owner")} className="btn btn-outline-warning btn-secondary-ui">
      BUY All NFT
    </button> */}
    <button onClick={() => navigate("/nft-search-adm0F7in26-coA4mpanb0Ay-de485tail73s-only-owner")} className="btn btn-outline-warning btn-secondary-ui">
      BUY All NFT
    </button>
  </div>

  

  <div className="row">

   {/* ===== Mint Resolver ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-warning text-dark">
          <i className="fa-solid fa-sliders"></i>
        </div>

        <h5 className="mt-3">
          <span className="text-warning">Set</span>{" "}
          <span className="fw-lighter">Mint Resolver</span>
        </h5>

        <p className="text-white">
          Control mint pricing and burn threshold dynamically.
        </p>

        <input
          type="text"
          className="form-control my-2"
          placeholder="Base Price (USDT)"
          value={basePrice}
          onChange={(e) => setBasePrice(e.target.value)}
        />

        <input
          type="text"
          className="form-control my-2"
          placeholder="Burn Threshold Price (USDT)"
          value={burnPrice}
          onChange={(e) => setBurnPrice(e.target.value)}
        />

        <button
          className="btn btn-warning w-100 mt-2"
          onClick={handleSetMintResolver}
        >
          <i className="fa-solid fa-gear me-2"></i>
          Update Resolver
        </button>
      </div>
    </div>



    {/* ===== Admin Batch Mint ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-danger">
          <i className="fa-solid fa-layer-group"></i>
        </div>

        <h5 className="mt-3">
          <span className="text-warning">Admin</span>{" "}
          <span className="fw-lighter">Batch Mint</span>
        </h5>

        <p className="text-white">
          Mint multiple NFTs in a single transaction securely.
        </p>

        <input
          type="text"
          min="1"
          className="form-control my-3"
          placeholder="Enter Mint Count"
          value={mintCount}
          onChange={(e) => setMintCount(Number(e.target.value))}
        />

        <button
          className="btn btn-danger w-100 mt-auto"
          onClick={handleAdminBatchMint}
        >
          <i className="fa-solid fa-bolt me-2"></i>
          Batch Mint
        </button>
      </div>
    </div>

    {/* ===== Royalty Distribution ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-success">
          <i className="fa-solid fa-coins"></i>
        </div>

        <h5 className="mt-3">
          <span className="text-warning">Royalty</span>{" "}
          <span className="fw-lighter">Distribution</span>
        </h5>

        <p className="text-white">
          Distribute accumulated royalty earnings to stakeholders.
        </p>
        

    {/* ===== Stats Section ===== */}
 <div className="row royalty-stats-row">

  {/* Eligible Users */}
  <div className="col-md-6">
    <div className="royalty-stat-box">

      <div className="royalty-stat-value">
  {totalQualifiedCount}
</div>

      <div className="royalty-stat-header">
        <i className="fa-solid fa-users royalty-stat-icon info"></i>
        <span className="royalty-stat-label">
          Users
        </span>
      </div>

    </div>
  </div>

  {/* Total Royalty Fund */}
  <div className="col-md-6">
    <div className="royalty-stat-box"> 
      <div className="royalty-stat-value">
      {poolValue ? `${poolValue} USDT` : "Loading..."}
      </div>

      <div className="royalty-stat-header">
        <i className="fa-solid fa-sack-dollar royalty-stat-icon success"></i>
        <span className="royalty-stat-label">
          Total Funds
        </span>
      </div>
    </div>
  </div>

</div>

    <input
      type="text"
      className="form-control mb-2"
      placeholder="User Wallet Address"
      value={royaltyUser}
      onChange={(e) => setRoyaltyUser(e.target.value)}
    />

    <input
      type="number"
      className="form-control mb-2"
      placeholder="Amount (USDT)"
      value={royaltyAmount}
      onChange={(e) => setRoyaltyAmount(e.target.value)}
    />

    <select
      className="form-control mb-3"
      value={royaltyRank}
      onChange={(e) => setRoyaltyRank(e.target.value)}
    >
      <option value="1">Rank 1</option>
      <option value="2">Rank 2</option>
      <option value="3">Rank 3</option>
      <option value="4">Rank 4</option>
    </select>



        <button
          className="btn btn-success w-100 mt-auto"
          onClick={handleDistributeRoyalty}
        >
          <i className="fa-solid fa-hand-holding-dollar me-2"></i>
          Distribute Royalty
        </button>
<br /> 
        <button
    className="btn btn-danger w-100"
    onClick={handleResetRoyalty}
    disabled={isResetting}
  >
    <i className="fa-solid fa-rotate-left me-2"></i>
    {isResetting ? "Resetting..." : "Reset Month"}
  </button>
      </div>
    </div>


     {/* ===== Manual User Registration ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-info">
          <i className="fa-solid fa-user-plus"></i>
        </div>
    
        <h5 className="mt-3">
          <span className="text-warning">User</span>{" "}
          <span className="fw-lighter">Registration</span>
        </h5>
    
        <p className="text-white">
          Register a user manually with referral and rank.
        </p>
    
        <input
          type="text"
          className="form-control my-2"
          placeholder="User Wallet Address"
          value={regWallet}
          onChange={(e) => setRegWallet(e.target.value)}
        />
    
        <input
          type="text"
          className="form-control my-2"
          placeholder="Referral Wallet Address"
          value={regReferral}
          onChange={(e) => setRegReferral(e.target.value)}
        />
    
        <select
          className="form-control my-2"
          value={regRank}
          onChange={(e) => setRegRank(Number(e.target.value))}
        >
          <option value={1}>Royalty Pool: 400 USDT</option>
          <option value={2}>Royalty Pool: 600 USDT</option>
          <option value={3}>Royalty Pool: 1000 USDT</option>
          <option value={4}>Royalty Pool: 1500 USDT</option>
        </select>
    
        <button
          className="btn btn-info w-100 mt-2"
          onClick={handleEnrollRegister}
        >
          <i className=""></i>
          Register User
        </button>
      </div>
    </div>
    
    {/* ===== Manual Package Purchase ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-success">
          <i className="fa-solid fa-cart-shopping"></i>
        </div>
    
        <h5 className="mt-3">
          <span className="text-warning">Manual</span>{" "}
          <span className="fw-lighter">Package Purchase</span>
        </h5>
    
        <p className="text-white">
          Purchase one or more packages (1–9) for a user.
        </p>
    
        <input
          type="text"
          className="form-control my-2"
          placeholder="User Wallet Address"
          value={purchaseWallet}
          onChange={(e) => setPurchaseWallet(e.target.value)}
        />
    
        {/* PACKAGE CHECKBOXES */}
       <div className="d-flex flex-wrap gap-2 my-2">
  {[
    { id: 0, label: "Cosmic Dust ($10)" },
    { id: 1, label: "Stardust Ember ($20)" },
    { id: 2, label: "Nebula Pulse ($50)" },
    { id: 3, label: "Astro Shimmer ($100)" },
    { id: 4, label: "Lunar Flux ($200)" },
    { id: 5, label: "Galaxy Surge ($400)" },
    { id: 6, label: "Solar Nova ($600)" },
    { id: 7, label: "Quantum Star ($1000)" },
    { id: 8, label: "Celestial Radiance ($1500)" },
  ].map((pkg) => (
    <label
      key={pkg.id}
      className={`btn btn-sm ${
        selectedPackages.includes(pkg.id)
          ? "btn-success"
          : "btn-outline-success"
      }`}
      onClick={() => togglePackage(pkg.id)}
    >
      {pkg.label}
    </label>
  ))}
</div>
    
        <button
          className="btn btn-success w-100 mt-2"
          onClick={handleEnrollPurchase}
        >
          <i className="fa-solid fa-check me-2"></i>
          Purchase Packages
        </button>
      </div>
    </div>
 
     {/* ===== Unlock Level Income ===== */}
    <div className="col-md-4 mb-4">
      <div className="card admin-card h-100 p-4">
        <div className="admin-card-icon bg-info">
          <i className="fa-solid fa-user-plus"></i>
        </div>
    
        <h5 className="mt-3">
          <span className="text-warning">Unlock Any User</span>{" "}
          <span className="fw-lighter">Level Income</span>
        </h5>
    
     
        <input
          type="text"
          className="form-control my-2"
          placeholder="User Wallet Address"
          value={lockWallet}
          onChange={(e) => setLockWallet(e.target.value)}
        />
    
        <button
          className="btn btn-info w-100 mt-2"
          onClick={handleLevelIncome}
        >
          <i className=""></i>
          Unlock Level
        </button>
      </div>
    </div>


    {/* ===== BlackList User Role Allocation ===== */}
<div className="col-md-4 mb-4">
  <div className="card admin-card h-100 p-4">

    <div className="admin-card-icon bg-warning text-dark">
      <i className="fa-solid fa-user-shield"></i>
    </div>

    <h5 className="mt-3">
      <span className="text-warning">Block</span>{" "}
      <span className="fw-lighter">Role Allocation</span>
    </h5>

    <p className="text-white">
      Assign or remove special role for any wallet.
    </p>

    <input
      type="text"
      className="form-control my-2"
      placeholder="User Wallet Address"
      value={roleWallet}
      onChange={(e) => setRoleWallet(e.target.value)}
    />

    <select
      className="form-control my-2"
      value={roleStatus}
      onChange={(e) => setRoleStatus(e.target.value === "true")}
    >
      <option value={true}>Enable Role</option>
      <option value={false}>Disable Role</option>
    </select>

    <button
      className="btn btn-warning w-100 mt-2"
      onClick={handleRoleAllocation}
    >
      <i className="fa-solid fa-user-gear me-2"></i>
      Update Role
    </button>

  </div>
</div>



{/* ===== Enable Trading Fund ===== */}
<div className="col-md-4 mb-4">
  <div className="card admin-card h-100 p-4">

    <div className="admin-card-icon bg-primary">
      <i className="fa-solid fa-wallet"></i>
    </div>

    <h5 className="mt-3">
      <span className="text-warning">Enable</span>{" "}
      <span className="fw-lighter">Trading Fund</span>
    </h5>

    <p className="text-white">
      Allocate trading fund to any user wallet manually.
    </p>

    <input
      type="text"
      className="form-control my-2"
      placeholder="User Wallet Address"
      value={fundWallet}
      onChange={(e) => setFundWallet(e.target.value)}
    />

    <input
      type="number"
      className="form-control my-2"
      placeholder="Amount (USDT)"
      value={fundAmount}
      onChange={(e) => setFundAmount(e.target.value)}
    />

    {/* Admin Note */}
    <div
      style={{
        background: "#fff3cd",
        border: "1px solid #ffeeba",
        color: "#856404",
        padding: "10px 12px",
        borderRadius: "6px",
        fontSize: "13px",
        marginTop: "10px"
      }}
    >
      ⚠️ <b>Admin Note:</b> Please verify the user's package and daily trading
      capacity before allocating funds. If funds exceed the user's allowed
      Bonus Capping it will be considered an administrative responsibility.
    </div>

    <button
      className="btn btn-primary w-100 mt-2"
      onClick={handleEnableFundUser}
    >
      <i className="fa-solid fa-coins me-2"></i>
      Enable Fund
    </button>

  </div>
</div>
   
  </div>
</div>

      {/* <h4 class="mb-3 mobilefiltername">
        <div><span class="text-warning"> Trading </span> <span class="fw-lighter"> Bot Users</span></div>
        <button className="btn btn-light btn-sm" onClick={() => setMobileFilterOpen(true)}>
          <FaFilter /> Filter
        </button>
      </h4>
 */}



{/* 
<div className="card paddingfilter">
  <div className="card-body">

      {mobileFilterOpen && <div className="overlay-bg" onClick={() => setMobileFilterOpen(false)} />}
  <div className={`bottom-filter-panel ${mobileFilterOpen ? "show" : ""}`}>

        <div className="close-filter" onClick={() => setMobileFilterOpen(false)}>✕</div>

      <div className="row">
        <div className="col-md-12 col-lg-2 mb-3">
          <label className="form-label">From Date</label>
          <div className="input-icon">
            <input type="date" className="form-control" />
            <i className="fa-solid fa-calendar iconposition"></i>
          </div>
        </div>

        <div className="col-md-12 col-lg-2 mb-3">
          <label className="form-label">To Date</label>
          <div className="input-icon">
            <input type="date" className="form-control" />
            <i className="fa-solid fa-calendar iconposition"></i>
          </div>
        </div>

        <div className="col-md-12 col-lg-3 mb-3">
          <label className="form-label">Search</label>
          <div className="input-icon">
            <input
              type="text"
              className="form-control only-inputypetext"
              placeholder="Search..."
            />
            <i className="fa-solid fa-magnifying-glass iconposition"></i>
          </div>
        </div>

        <div className="col-md-12 col-lg-2 mb-3">
          <label className="visibilty-hidden form-label">Search</label>
          <div className="d-flex gap-2 mobleapplybtn">
            <button className="btn btn-success">Apply</button>
            <button className="btn btn-danger">Reset</button>
          </div>
        </div>
      </div>
 </div>
      
          {botLoading ? (
            <p className="text-white">Loading...</p>
          ) : filteredUsers.length === 0 ? (
            <p className="text-white">No bot users found</p>
          ) : (
            <div className="row">
              {filteredUsers.map((u, i) => (
                <div className="col-md-6 col-xl-4 mb-4" key={i}>
                  <div className="ref-card">
                    <div className="ref-card-body">

                      <div className="ref-row">
                        <span className="ref-label">S.No</span>
                        <span className="ref-value">{i + 1}</span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">From Wallet</span>
                        <span className="ref-value">
                          {u.Wallet
                            ? `${u.Wallet.slice(0, 6)}...${u.Wallet.slice(-4)}`
                            : "-"}
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">USDT Limit</span>
                        <span className="ref-value">
                          {web3
                            ? Web3.utils.fromWei(u.USDTLimits, "ether")
                            : "0"}{" "}
                          USDT
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">Actual Limit</span>
                        <span className="ref-value">{u.ActualLimits}</span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">Active Date</span>
                        <span className="ref-date">
                          {new Date(u.ActiveDateTime).toLocaleString()}
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">Expiry Date</span>
                        <span className="ref-date">
                          {new Date(u.ExpiryDateTime).toLocaleString()}
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">Status</span>
                        {u.BotStatus === 1 ? (
                          <span className="badge bg-success">Active</span>
                        ) : (
                          <span className="badge bg-danger">Inactive</span>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

      </div>
    </div> */}



      {/* ===== MODAL (NOW IT WILL WORK 100%) ===== */}
      <ConfirmBuyModal
        open={modalStatus.visible}
        status={{ ...modalStatus, setStatusText: setModalStatus }}
        onClose={() =>
          setModalStatus({ ...modalStatus, visible: false })
        }
      />
    </>
  );
};

export default AdminPanel;
